import { ChangeDetectorRef, Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PopoverController } from '@ionic/angular';
import { Orders } from 'src/app/models/Orders.model';
import { IWsResult } from 'src/app/models/ws_result.model';
import { OrdersService } from 'src/app/services/orders.service';

/**
 * Popover info prodotti — aperto via `AlertsService.presentProductsInfo()`
 * (hover 1s sul N° ordine nelle liste preparazione-ordini).
 *
 * Cleanup v2.11.0 J.3:
 * - Switch a inject() + takeUntilDestroyed.
 * - Drop console.log "order in popover".
 * - Drop commented dead code.
 * - Visual Diakonix native (drop kendo-label, no più inline styles).
 *
 * 🚨 FIX v2.12.4 (B1): vive dentro Ionic `PopoverController` — overlay
 * isolato dal CD tree principale. `loading = false` settato in
 * subscribe.next/error NON triggera re-render del template → loader
 * infinito anche dopo che il BE ha risposto. Fix: `cdr.detectChanges()`
 * post next + error (5a ricorrenza del pattern dopo v2.11.1 J.3,
 * v2.11.2 Q4, v2.11.2 Q6, v2.12.0 Q7, v2.12.2 change-operator).
 * **Lint rule promossa a Sprint 1 Phase 2 priority.**
 */
@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrl: './product-info.component.scss',
  standalone: false,
})


export class ProductInfoComponent implements OnInit {

  @Input() orderId!: number;
  public order: Orders.Order | null = null;
  public loading = true;

  private destroyRef = inject(DestroyRef);
  private ordersServ = inject(OrdersService);
  private popoverCtrl = inject(PopoverController);
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loading = true;
    this.ordersServ
      .getOrder(`${this.orderId}`)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (orderData: IWsResult) => {
          this.order = orderData?.data
            ? new Orders.Order(orderData.data)
            : null;
          this.loading = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.loading = false;
          this.cdr.detectChanges();
        },
      });
  }

  close(): void {
    this.popoverCtrl.dismiss();
  }

}
